import React from "react";
import { useTabsState } from "./hooks/use-tabs-state";
export function Tabs() {
    const { handleTabClicked, tabs } = useTabsState();
    return (React.createElement("div", { className: "w-full flex justify-center gap-4" }, tabs?.map(({ identifier, label, selected = false }) => (React.createElement("button", { key: identifier, className: `border w-full max-w-52 rounded-xl py-2 ${selected ? "bg-neutral-blue border-primary shadow-lg" : "bg-light-blue border-transparent"}`, onClick: handleTabClicked(identifier), type: "button" },
        React.createElement("div", { className: "w-full flex justify-center" },
            React.createElement("div", { className: "font-semibold" }, label)))))));
}
